<template>
    <div>
        <SubHeader :text="$t('h.awards')" :imgUrl="img" />
        <div class="wrap">
            <Card
                v-for="(item, index) in awards"
                :key="index"
                :img="item.img"
                :name="item.name"
                @click.native="showBig(item.img)"
            />
        </div>
        <div class="mark" v-show="visible">
            <img
                class="close"
                :src="require('@/assets/img_svg/close.svg')"
                alt="svg"
                @click="close"
            />
            <img class="show-img" :src="showImg" alt="showImg" />
        </div>
    </div>
</template>
<script>
import SubHeader from "@/components/SubHeader";
import Card from "./Card";
import initAnimation from "../animation";
export default {
    data() {
        return {
            img: require("@/assets/images/sub_page_banner_12.jpg"),
            awards: [
                {
                    img: require("@/assets/images/awards/SD-WAN.png"),
                    name: "SD-WAN Ready Certificate",
                },
                {
                    img: require("@/assets/images/new/1_1.png"),
                    name: "SD-WAN Ready Certificate",
                },
                {
                    img: require("@/assets/images/new/1_2.png"),
                    name: "SD-WAN Ready Certificate",
                },
            ],
            showImg: require("@/assets/images/awards/SD-WAN.png"),
            visible: false,
        };
    },
    components: {
        SubHeader,
        Card,
    },
    methods: {
        close: function() {
            this.visible = false;
        },
        showBig: function(img) {
            this.showImg = img;
            this.visible = true;
        },
    },
    mounted() {
        setTimeout(initAnimation, 0);
    },
};
</script>
<style scoped>
.wrap {
    width: 1200px;
    margin: 100px auto 100px;
    overflow: hidden;
}
.mark {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 99999999999;
}
.close {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 30px;
    top: 30px;
    cursor: pointer;
}
.show-img {
    max-width: 1100px;
    max-height: 600px;
    position: absolute;
    top: 50%;
    transform: translate(50%, -50%);
    right: 50%;
}
</style>



// WEBPACK FOOTER //
// src/Pages/Awards/Awards.vue